import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { useAuth } from '../lib/auth';

/**
 * Polling del último sync incremental de Alegra.
 * Devuelve { lastRun: ISO|null, minutesAgo: number|null, status: 'fresh'|'stale'|'old' }
 *  - fresh: < 10 min
 *  - stale: 10-30 min
 *  - old:   > 30 min
 */
export function useAlegraFreshness() {
  const { user } = useAuth();
  const [state, setState] = useState({ lastRun: null, minutesAgo: null, status: 'unknown' });

  const fetchStatus = useCallback(async () => {
    if (!user) return;
    try {
      const res = await api.get('/alegra/sync-incremental/status');
      const lastRun = res.data?.last_run || null;
      if (!lastRun) {
        setState({ lastRun: null, minutesAgo: null, status: 'unknown' });
        return;
      }
      const ms = Date.now() - new Date(lastRun).getTime();
      const minutesAgo = Math.floor(ms / 60000);
      const status = minutesAgo < 10 ? 'fresh' : minutesAgo < 30 ? 'stale' : 'old';
      setState({ lastRun, minutesAgo, status });
    } catch {
      // silent
    }
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000);
    const onFocus = () => fetchStatus();
    window.addEventListener('focus', onFocus);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [user, fetchStatus]);

  return state;
}
